<template>
  <path
    d="M12.79 3.00018H8C6.9 3.00018 6 3.90018 6 5.00018V19.0002C6 20.1002 6.9 21.0002 8 21.0002C9.1 21.0002 10 20.1002 10 19.0002V15.0002H13C16.57 15.0002 19.42 11.8702 18.95 8.21018C18.56 5.19018 15.84 3.00018 12.79 3.00018ZM13.2 11.0002H10V7.00018H13.2C14.3 7.00018 15.2 7.90018 15.2 9.00018C15.2 10.1002 14.3 11.0002 13.2 11.0002Z"
  />
</template>
